import api from "./api";
import { SYNC_RECORDS_TIMEOUT_MS } from "../offline/offlineSyncConfig";

export const offlineSyncService = {
  getSummary: async (token, { signal } = {}) => {
    const res = await api.get("/repo-cases/offline-sync/summary", {
      signal,
      timeout: 60000,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  getRecords: async (token, params, { signal } = {}) => {
    const res = await api.get("/repo-cases/offline-sync/records", {
      params,
      signal,
      timeout: SYNC_RECORDS_TIMEOUT_MS,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  getIds: async (token, params, { signal } = {}) => {
    const res = await api.get("/repo-cases/offline-sync/ids", {
      params,
      signal,
      timeout: SYNC_RECORDS_TIMEOUT_MS,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },
};
